import WildAppResource from "./WildAppResource";
import UserAppResource from "./UserAppResource";
import LuStateAppResource from "./LuStateAppResource";

export const TYPE_AGENT = 'agent';
export const TYPE_BROKER = 'broker';

export const IDENTIFIER_TYPE_LICENSE = 'license';
export const IDENTIFIER_TYPE_NRSD = 'nrds';

class ProfessionalLicenseAppResource extends WildAppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'professional-license';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'professionals/licenses';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'type',
      'identifierType',
      'state',
      'issuingBody',
      'number',
      'userUuid',
      'user',
      'stateId',
      'state',
      'verified',
      'notificationLastSentAt',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      user: UserAppResource,
      state: LuStateAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      user: "user_uuid",
      state: "state_id",
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      userUuid: {
        presence: true,
        type: 'string',
      },

      type: {
        presence: true,
        type: 'string',
      },

      identifierType: {
        presence: true,
        type: 'string',
      },

      stateId: {
        presence: true,
        numericality: true,
      },

      issuingBody: {
        presence: true,
        type: 'string',
      },

      number: {
        presence: true,
        type: 'string',
      },

      verified: {
        presence: true,
        type: 'boolean'
      },
    };
  }
}

export default ProfessionalLicenseAppResource;
